export default {"src":"/_next/static/media/qoute-end.d8a3c388.svg","height":28,"width":37,"blurWidth":0,"blurHeight":0};